import Sidebar from "./Sidebar";
import { ReportMenuData, SidebarItem } from "../models/SidebarItem";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import ReportContext from "../context/ReportProvider";

const Report = () => {
  const {category} = useParams();
  const navigate = useNavigate();
  const { hasClaim } = useAuth();
  const { initializeReportInputs } = useContext(ReportContext);
  const [filteredSidebarItems, setFilteredSidebarItems] = useState<
    SidebarItem[]
  >([]);

  useEffect(() => {    
    //reset report context
    let reportCategory = undefined;
    if (category)
      reportCategory = category === "settlements" ? "settlement" : "authrequest"
    initializeReportInputs(reportCategory);
  }, [navigate]);

  useEffect(() => {
    const filtered = filterItems();
    setFilteredSidebarItems(filtered);
    if ((filtered?.length ?? 0) === 0) navigate("/NoPermission");
  }, []);

  const filterItems = (): SidebarItem[] => {
    const transformedData = ReportMenuData.map((item) => {
      const filteredValues = item.subItems?.filter((val) =>
        hasClaim(val?.claim ?? "")
      );
      return {
        id: item.id,
        name: item.name,
        path: item.path,
        claim: item.claim,
        icon: item.icon,
        subItems: filteredValues,
      };
    });

    return transformedData;
  };

  return (
    <>
      <div className="app-container">
        <div className="sidebar-container">
          <Sidebar items={filteredSidebarItems} />
        </div>
        <Outlet />
      </div>
    </>
  );
};

export default Report;
